export const ECONOMIC_ACTIVITIES = [
  {
    code: '011101',
    activity: 'CULTIVO DE TRIGO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011102',
    activity: 'CULTIVO DE MAÍZ',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011103',
    activity: 'CULTIVO DE AVENA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011104',
    activity: 'CULTIVO DE CEBADA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011105',
    activity: 'CULTIVO DE OTROS CEREALES (EXCEPTO TRIGO, MAÍZ, AVENA Y CEBADA)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011106',
    activity: 'CULTIVO DE POROTOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011107',
    activity: 'CULTIVO DE LUPINO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011108',
    activity: 'CULTIVO DE OTRAS LEGUMBRES (EXCEPTO POROTOS Y LUPINO)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011109',
    activity: 'CULTIVO DE SEMILLAS DE RAPS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011110',
    activity: 'CULTIVO DE SEMILLAS DE MARAVILLA (GIRASOL)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011111',
    activity:
      'CULTIVO DE SEMILLAS DE CEREALES, LEGUMBRES Y OLEAGINOSAS (EXCEPTO SEMILLASDE RAPS Y MARAVILLA)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011200',
    activity: 'CULTIVO DE ARROZ',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011301',
    activity: 'CULTIVO DE PAPAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011302',
    activity: 'CULTIVO DE CAMOTES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011303',
    activity: 'CULTIVO DE OTROS TUBÉRCULOS (EXCEPTO PAPAS Y CAMOTES)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011304',
    activity: 'CULTIVO DE REMOLACHA AZUCARERA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011305',
    activity: 'CULTIVO DE SEMILLAS DE HORTALIZAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011306',
    activity: 'CULTIVO DE HORTALIZAS Y MELONES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011400',
    activity: 'CULTIVO DE CAÑA DE AZÚCAR',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011500',
    activity: 'CULTIVO DE TABACO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011600',
    activity: 'CULTIVO DE PLANTAS DE FIBRA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011901',
    activity: 'CULTIVO DE FLORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011902',
    activity:
      'CULTIVOS FORRAJEROS EN PRADERAS MEJORADAS O SEMBRADAS; CULTIVOSSUPLEMENTARIOS FORRAJEROS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '011903',
    activity:
      'CULTIVOS DE SEMILLAS DE FLORES; CULTIVO DE SEMILLAS DE PLANTAS FORRAJERAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012111',
    activity: 'CULTIVO DE UVA DESTINADA A LA PRODUCCIÓN DE PISCO Y AGUARDIENTE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012112',
    activity: 'CULTIVO DE UVA DESTINADA A LA PRODUCCIÓN DE VINO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012120',
    activity: 'CULTIVO DE UVA PARA MESA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012200',
    activity:
      'CULTIVO DE FRUTAS TROPICALES Y SUBTROPICALES (INCLUYE EL CULTIVO DE PALTAS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012300',
    activity: 'CULTIVO DE CÍTRICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012400',
    activity: 'CULTIVO DE FRUTAS DE PEPITA Y DE HUESO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012501',
    activity: 'CULTIVO DE SEMILLAS DE FRUTAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012502',
    activity: 'CULTIVO DE OTROS FRUTOS Y NUECES DE ÁRBOLES Y ARBUSTOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012600',
    activity: 'CULTIVO DE FRUTOS OLEAGINOSOS (INCLUYE EL CULTIVO DE ACEITUNAS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012700',
    activity:
      'CULTIVO DE PLANTAS CON LAS QUE SE PREPARAN BEBIDAS (INCLUYE EL CULTIVO DECAFÉ, TÉ Y MATE)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012801',
    activity: 'CULTIVO DE ESPECIAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012802',
    activity: 'CULTIVO DE PLANTAS AROMÁTICAS, MEDICINALES Y FARMACÉUTICAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '012900',
    activity: 'CULTIVO DE OTRAS PLANTAS PERENNES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '013000',
    activity:
      'CULTIVO DE PLANTAS VIVAS INCLUIDA LA PRODUCCIÓN EN VIVEROS (EXCEPTOVIVEROS FORESTALES)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '014101',
    activity: 'CRÍA DE GANADO BOVINO PARA LA PRODUCCIÓN LECHERA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '014102',
    activity:
      'CRÍA DE GANADO BOVINO PARA LA PRODUCCIÓN DE CARNE O COMOGANADO REPRODUCTOR',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '014200',
    activity: 'CRÍA DE CABALLOS Y OTROS EQUINOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '014300',
    activity: 'CRÍA DE LLAMAS, ALPACAS, VICUÑAS, GUANACOS Y OTROSCAMÉLIDOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '014410',
    activity: 'CRÍA DE OVEJAS (OVINOS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '014420',
    activity: 'CRÍA DE CABRAS (CAPRINOS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '014500',
    activity: 'CRÍA DE CERDOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '014601',
    activity: 'CRÍA DE AVES DE CORRAL PARA LA PRODUCCIÓN DE CARNE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '014602',
    activity: 'CRÍA DE AVES DE CORRAL PARA LA PRODUCCIÓN DE HUEVOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '014901',
    activity: 'APICULTURA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '014909',
    activity: 'CRÍA DE OTROS ANIMALES N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '015000',
    activity:
      'CULTIVO DE PRODUCTOS AGRÍCOLAS EN COMBINACIÓN CON LACRÍA DE ANIMALES (EXPLOTACIÓN MIXTA)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '016100',
    activity: 'ACTIVIDADES DE APOYO A LA AGRICULTURA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '016200',
    activity: 'ACTIVIDADES DE APOYO A LA GANADERÍA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '016300',
    activity: 'ACTIVIDADES POSCOSECHA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '016400',
    activity: 'TRATAMIENTO DE SEMILLAS PARA PROPAGACIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '017000',
    activity:
      'CAZA ORDINARIA Y MEDIANTE TRAMPAS Y ACTIVIDADES DE SERVICIOS CONEXAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '021001',
    activity: 'EXPLOTACIÓN DE VIVEROS FORESTALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '021002',
    activity:
      'SILVICULTURA Y OTRAS ACTIVIDADES FORESTALES (EXCEPTO EXPLOTACIÓN DEVIVEROS FORESTALES)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '022000',
    activity: 'EXTRACCIÓN DE MADERA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '023000',
    activity: 'RECOLECCIÓN DE PRODUCTOS FORESTALES DISTINTOS DE LA MADERA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '024001',
    activity:
      'SERVICIOS DE FORESTACIÓN A CAMBIO DE UNA RETRIBUCIÓN O PORCONTRATA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '024002',
    activity:
      'SERVICIOS DE CORTA DE MADERA A CAMBIO DE UNA RETRIBUCIÓN O PORCONTRATA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '024003',
    activity: 'SERVICIOS DE EXTINCIÓN Y PREVENCIÓN DE INCENDIOS FORESTALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '024009',
    activity: 'OTROS SERVICIOS DE APOYO A LA SILVICULTURA N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '031110',
    activity: 'PESCA MARÍTIMA INDUSTRIAL, EXCEPTO DE BARCOS FACTORÍA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '031120',
    activity: 'PESCA MARÍTIMA ARTESANAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '031130',
    activity: 'RECOLECCIÓN Y EXTRACCIÓN DE PRODUCTOS MARINOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '031140',
    activity: 'SERVICIOS RELACIONADOS CON LA PESCA MARÍTIMA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '031200',
    activity: 'PESCA DE AGUA DULCE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '032110',
    activity: 'CULTIVO Y CRIANZA DE PECES MARINOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '032120',
    activity: 'CULTIVO, REPRODUCCIÓN Y MANEJO DE ALGAS MARINAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '032130',
    activity: 'REPRODUCCIÓN Y CRÍA DE MOLUSCOS, CRUSTÁCEOS Y GUSANOSMARINOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '032140',
    activity: 'SERVICIOS RELACIONADOS CON LA ACUICULTURA MARINA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '032200',
    activity: 'ACUICULTURA DE AGUA DULCE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '040000',
    activity: 'EXTRACCIÓN Y PROCESAMIENTO DE COBRE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '051000',
    activity: 'EXTRACCIÓN DE CARBÓN DE PIEDRA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '052000',
    activity: 'EXTRACCIÓN DE LIGNITO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '061000',
    activity: 'EXTRACCIÓN DE PETRÓLEO CRUDO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '062000',
    activity: 'EXTRACCIÓN DE GAS NATURAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '071000',
    activity: 'EXTRACCIÓN DE MINERALES DE HIERRO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '072100',
    activity: 'EXTRACCIÓN DE MINERALES DE URANIO Y TORIO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '072910',
    activity: 'EXTRACCIÓN DE ORO Y PLATA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '072991',
    activity: 'EXTRACCIÓN DE ZINC Y PLOMO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '072992',
    activity: 'EXTRACCIÓN DE MANGANESO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '072999',
    activity:
      'EXTRACCIÓN DE OTROS MINERALES METALÍFEROS NO FERROSOS N.C.P.(EXCEPTO ZINC, PLOMO Y MANGANESO)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '081000',
    activity: 'EXTRACCIÓN DE PIEDRA, ARENA Y ARCILLA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '089110',
    activity: 'EXTRACCIÓN Y PROCESAMIENTO DE LITIO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '089190',
    activity:
      'EXTRACCIÓN DE MINERALES PARA LA FABRICACIÓN DE ABONOS YPRODUCTOS QUÍMICOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '089200',
    activity: 'EXTRACCIÓN DE TURBA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '089300',
    activity: 'EXTRACCIÓN DE SAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '089900',
    activity: 'EXPLOTACIÓN DE OTRAS MINAS Y CANTERAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '091001',
    activity:
      'ACTIVIDADES DE APOYO PARA LA EXTRACCIÓN DE PETRÓLEO Y GASNATURAL PRESTADOS POR EMPRESAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '091002',
    activity:
      'ACTIVIDADES DE APOYO PARA LA EXTRACCIÓN DE PETRÓLEO Y GASNATURAL PRESTADOS POR PROFESIONALES',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '099001',
    activity:
      'ACTIVIDADES DE APOYO PARA LA EXPLOTACIÓN DE OTRAS MINAS Y CANTERASPRESTADOS POR EMPRESAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '099002',
    activity:
      'ACTIVIDADES DE APOYO PARA LA EXPLOTACIÓN DE OTRAS MINAS Y CANTERASPRESTADOS POR PROFESIONALES',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '101011',
    activity:
      'EXPLOTACIÓN DE MATADEROS DE BOVINOS, OVINOS, EQUINOS, CAPRINOS,PORCINOS Y CAMÉLIDOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '101019',
    activity:
      'EXPLOTACIÓN DE MATADEROS DE AVES Y DE OTROS TIPOS DE ANIMALES N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '101020',
    activity: 'ELABORACIÓN Y CONSERVACIÓN DE CARNE Y PRODUCTOSCÁRNICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '102010',
    activity: 'PRODUCCIÓN DE HARINA DE PESCADO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '102020',
    activity: 'ELABORACIÓN Y CONSERVACIÓN DE SALMÓNIDOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '102030',
    activity:
      'ELABORACIÓN Y CONSERVACIÓN DE OTROS PESCADOS, EN PLANTAS ENTIERRA (EXCEPTO BARCOS FACTORÍA)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '102040',
    activity:
      'ELABORACIÓN Y CONSERVACIÓN DE CRUSTÁCEOS, MOLUSCOS YOTROS PRODUCTOS ACUÁTICOS, EN PLANTAS EN TIERRA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '102050',
    activity:
      'ACTIVIDADES DE ELABORACIÓN Y CONSERVACIÓN DE PESCADO,REALIZADAS EN BARCOS FACTORÍA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '102060',
    activity: 'ELABORACIÓN Y PROCESAMIENTO DE ALGAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '103000',
    activity: 'ELABORACIÓN Y CONSERVACIÓN DE FRUTAS, LEGUMBRES Y HORTALIZAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '104000',
    activity:
      'ELABORACIÓN DE ACEITES Y GRASAS DE ORIGEN VEGETAL Y ANIMAL (EXCEPTOELABORACIÓN DE MANTEQUILLA)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '105000',
    activity: 'ELABORACIÓN DE PRODUCTOS LÁCTEOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '106101',
    activity: 'MOLIENDA DE TRIGO: PRODUCCIÓN DE HARINA, SÉMOLA YGRÁNULOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '106102',
    activity: 'MOLIENDA DE ARROZ; PRODUCCIÓN DE HARINA DE ARROZ',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '106109',
    activity: 'ELABORACIÓN DE OTROS PRODUCTOS DE MOLINERÍA N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '106200',
    activity: 'ELABORACIÓN DE ALMIDONES Y PRODUCTOS DERIVADOS DEL ALMIDÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '107100',
    activity: 'ELABORACIÓN DE PRODUCTOS DE PANADERÍA Y PASTELERÍA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '107200',
    activity: 'ELABORACIÓN DE AZÚCAR',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '107300',
    activity: 'ELABORACIÓN DE CACAO, CHOCOLATE Y DE PRODUCTOS DE CONFITERÍA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '107400',
    activity:
      'ELABORACIÓN DE MACARRONES, FIDEOS, ALCUZCUZ Y PRODUCTOSFARINÁCEOS SIMILARES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '107500',
    activity:
      'ELABORACIÓN DE COMIDAS Y PLATOS PREPARADOS ENVASADOS, ROTULADOS Y CONINFORMACIÓN NUTRICIONAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '107901',
    activity: 'ELABORACIÓN DE TÉ, CAFÉ, MATE E INFUSIONES DE HIERBAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '107902',
    activity: 'ELABORACIÓN DE LEVADURAS NATURALES O ARTIFICIALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '107903',
    activity:
      'ELABORACIÓN DE VINAGRES, MOSTAZAS, MAYONESAS Y CONDIMENTOS EN GENERAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '107909',
    activity: 'ELABORACIÓN DE OTROS PRODUCTOS ALIMENTICIOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '108000',
    activity: 'ELABORACIÓN DE PIENSOS PREPARADOS PARA ANIMALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '110110',
    activity: 'ELABORACIÓN DE PISCO (INDUSTRIAS PISQUERAS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '110120',
    activity:
      'DESTILACIÓN, RECTIFICACIÓN Y MEZCLAS DE BEBIDASALCOHÓLICAS; EXCEPTO PISCO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '110200',
    activity: 'ELABORACIÓN DE VINOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '110300',
    activity: 'ELABORACIÓN DE BEBIDAS MALTEADAS Y DE MALTA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '110401',
    activity: 'ELABORACIÓN DE BEBIDAS NO ALCOHÓLICAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '110402',
    activity: 'PRODUCCIÓN DE AGUAS MINERALES Y OTRAS AGUAS EMBOTELLADAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '120001',
    activity: 'ELABORACIÓN DE CIGARROS Y CIGARRILLOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '120009',
    activity: 'ELABORACIÓN DE OTROS PRODUCTOS DE TABACO N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '131100',
    activity: 'PREPARACIÓN E HILATURA DE FIBRAS TEXTILES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '131200',
    activity: 'TEJEDURA DE PRODUCTOS TEXTILES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '131300',
    activity: 'ACABADO DE PRODUCTOS TEXTILES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '139100',
    activity: 'FABRICACIÓN DE TEJIDOS DE PUNTO Y GANCHILLO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '139200',
    activity:
      'FABRICACIÓN DE ARTÍCULOS CONFECCIONADOS DE MATERIALESTEXTILES, EXCEPTO PRENDAS DE VESTIR',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '139300',
    activity: 'FABRICACIÓN DE TAPICES Y ALFOMBRAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '139400',
    activity: 'FABRICACIÓN DE CUERDAS, CORDELES, BRAMANTES Y REDES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '139900',
    activity: 'FABRICACIÓN DE OTROS PRODUCTOS TEXTILES N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '141001',
    activity:
      'FABRICACIÓN DE PRENDAS DE VESTIR DE MATERIALES TEXTILES Y SIMILARES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '141002',
    activity: 'FABRICACIÓN DE PRENDAS DE VESTIR DE CUERO NATURAL O ARTIFICIAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '141003',
    activity: 'FABRICACIÓN DE ACCESORIOS DE VESTIR',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '141004',
    activity: 'FABRICACIÓN DE ROPA DE TRABAJO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '142000',
    activity: 'FABRICACIÓN DE ARTÍCULOS DE PIEL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '143000',
    activity: 'FABRICACIÓN DE ARTÍCULOS DE PUNTO Y GANCHILLO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '151100',
    activity: 'CURTIDO Y ADOBO DE CUEROS; ADOBO Y TEÑIDO DE PIELES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '151200',
    activity:
      'FABRICACIÓN DE MALETAS, BOLSOS Y ARTÍCULOS SIMILARES,ARTÍCULOS DE TALABARTERÍA Y GUARNICIONERÍA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '152000',
    activity: 'FABRICACIÓN DE CALZADO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '161000',
    activity: 'ASERRADO Y ACEPILLADURA DE MADERA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '162100',
    activity:
      'FABRICACIÓN DE HOJAS DE MADERA PARA ENCHAPADO Y TABLEROS A BASE DEMADERA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '162200',
    activity:
      'FABRICACIÓN DE PARTES Y PIEZAS DE CARPINTERÍA PARA EDIFICIOS YCONSTRUCCIONES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '162300',
    activity: 'FABRICACIÓN DE RECIPIENTES DE MADERA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '162900',
    activity:
      'FABRICACIÓN DE OTROS PRODUCTOS DE MADERA, DE ARTÍCULOS DECORCHO, PAJA Y MATERIALES TRENZABLES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '170110',
    activity: 'FABRICACIÓN DE CELULOSA Y OTRAS PASTAS DE MADERA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '170190',
    activity:
      'FABRICACIÓN DE PAPEL Y CARTÓN PARA SU POSTERIOR USO INDUSTRIALN.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '170200',
    activity:
      'FABRICACIÓN DE PAPEL Y CARTÓN ONDULADO Y DE ENVASES DE PAPEL YCARTÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '170900',
    activity: 'FABRICACIÓN DE OTROS ARTÍCULOS DE PAPEL Y CARTÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '181101',
    activity: 'IMPRESIÓN DE LIBROS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '181109',
    activity: 'OTRAS ACTIVIDADES DE IMPRESIÓN N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '181200',
    activity: 'ACTIVIDADES DE SERVICIOS RELACIONADAS CON LA IMPRESIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '182000',
    activity: 'REPRODUCCIÓN DE GRABACIONES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '191000',
    activity: 'FABRICACIÓN DE PRODUCTOS DE HORNOS DE COQUE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '192000',
    activity: 'FABRICACIÓN DE PRODUCTOS DE LA REFINACIÓN DEL PETRÓLEO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '201101',
    activity:
      'FABRICACIÓN DE CARBÓN VEGETAL (EXCEPTO ACTIVADO);FABRICACIÓN DE BRIQUETAS DE CARBÓN VEGETAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '201109',
    activity: 'FABRICACIÓN DE OTRAS SUSTANCIAS QUÍMICAS BÁSICAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '201200',
    activity: 'FABRICACIÓN DE ABONOS Y COMPUESTOS DE NITRÓGENO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '201300',
    activity: 'FABRICACIÓN DE PLÁSTICOS Y CAUCHO SINTÉTICO EN FORMASPRIMARIAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '202100',
    activity:
      'FABRICACIÓN DE PLAGUICIDAS Y OTROS PRODUCTOS QUÍMICOS DE USOAGROPECUARIO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '202200',
    activity:
      'FABRICACIÓN DE PINTURAS, BARNICES Y PRODUCTOS DE REVESTIMIENTO,TINTAS DE IMPRENTA Y MASILLAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '202300',
    activity:
      'FABRICACIÓN DE JABONES Y DETERGENTES, PREPARADOS PARA LIMPIAR,PERFUMES Y PREPARADOS DE TOCADOR',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '202901',
    activity: 'FABRICACIÓN DE EXPLOSIVOS Y PRODUCTOS PIROTÉCNICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '202909',
    activity: 'FABRICACIÓN DE OTROS PRODUCTOS QUÍMICOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '203000',
    activity: 'FABRICACIÓN DE FIBRAS ARTIFICIALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '210000',
    activity:
      'FABRICACIÓN DE PRODUCTOS FARMACÉUTICOS, SUSTANCIASQUÍMICAS MEDICINALES Y PRODUCTOS BOTÁNICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '221100',
    activity:
      'FABRICACIÓN DE CUBIERTAS Y CÁMARAS DE CAUCHO; RECAUCHUTADO YRENOVACIÓN DE CUBIERTAS DE CAUCHO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '221900',
    activity: 'FABRICACIÓN DE OTROS PRODUCTOS DE CAUCHO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '222000',
    activity: 'FABRICACIÓN DE PRODUCTOS DE PLÁSTICO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '231001',
    activity: 'FABRICACIÓN DE VIDRIO PLANO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '231002',
    activity: 'FABRICACIÓN DE VIDRIO HUECO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '231003',
    activity: 'FABRICACIÓN DE FIBRAS DE VIDRIO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '231009',
    activity: 'FABRICACIÓN DE PRODUCTOS DE VIDRIO N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '239100',
    activity: 'FABRICACIÓN DE PRODUCTOS REFRACTARIOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '239200',
    activity: 'FABRICACIÓN DE MATERIALES DE CONSTRUCCIÓN DE ARCILLA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '239300',
    activity: 'FABRICACIÓN DE OTROS PRODUCTOS DE PORCELANA Y DE CERÁMICA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '239400',
    activity: 'FABRICACIÓN DE CEMENTO, CAL Y YESO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '239500',
    activity: 'FABRICACIÓN DE ARTÍCULOS DE HORMIGÓN, CEMENTO Y YESO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '239600',
    activity: 'CORTE, TALLA Y ACABADO DE LA PIEDRA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '239900',
    activity: 'FABRICACIÓN DE OTROS PRODUCTOS MINERALES NO METÁLICOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '241000',
    activity: 'INDUSTRIAS BÁSICAS DE HIERRO Y ACERO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '242001',
    activity: 'FABRICACIÓN DE PRODUCTOS PRIMARIOS DE COBRE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '242002',
    activity: 'FABRICACIÓN DE PRODUCTOS PRIMARIOS DE ALUMINIO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '242009',
    activity:
      'FABRICACIÓN DE PRODUCTOS PRIMARIOS DE METALES PRECIOSOS Y DE OTROSMETALES NO FERROSOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '243100',
    activity: 'FUNDICIÓN DE HIERRO Y ACERO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '243200',
    activity: 'FUNDICIÓN DE METALES NO FERROSOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '251100',
    activity: 'FABRICACIÓN DE PRODUCTOS METÁLICOS PARA USO ESTRUCTURAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '251201',
    activity:
      'FABRICACIÓN DE RECIPIENTES DE METAL PARA GASES COMPRIMIDOS O LICUADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '251209',
    activity: 'FABRICACIÓN DE TANQUES, DEPÓSITOS Y RECIPIENTES DE METALN.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '251300',
    activity:
      'FABRICACIÓN DE GENERADORES DE VAPOR, EXCEPTO CALDERAS DE AGUACALIENTE PARA CALEFACCIÓN CENTRAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '252000',
    activity: 'FABRICACIÓN DE ARMAS Y MUNICIONES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '259100',
    activity:
      'FORJA, PRENSADO, ESTAMPADO Y LAMINADO DE METALES; PULVIMETALURGIA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '259200',
    activity: 'TRATAMIENTO Y REVESTIMIENTO DE METALES; MAQUINADO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '259300',
    activity:
      'FABRICACIÓN DE ARTÍCULOS DE CUCHILLERÍA, HERRAMIENTASDE MANO Y ARTÍCULOS DE FERRETERÍA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '259900',
    activity: 'FABRICACIÓN DE OTROS PRODUCTOS ELABORADOS DE METAL N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '261000',
    activity: 'FABRICACIÓN DE COMPONENTES Y TABLEROS ELECTRÓNICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '262000',
    activity: 'FABRICACIÓN DE COMPUTADORES Y EQUIPO PERIFÉRICO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '263000',
    activity: 'FABRICACIÓN DE EQUIPO DE COMUNICACIONES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '264000',
    activity: 'FABRICACIÓN DE APARATOS ELECTRÓNICOS DE CONSUMO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '265100',
    activity: 'FABRICACIÓN DE EQUIPO DE MEDICIÓN, PRUEBA, NAVEGACIÓN YCONTROL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '265200',
    activity: 'FABRICACIÓN DE RELOJES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '266000',
    activity:
      'FABRICACIÓN DE EQUIPO DE IRRADIACIÓN Y EQUIPOELECTRÓNICO DE USO MÉDICO Y TERAPÉUTICO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '267000',
    activity: 'FABRICACIÓN DE INSTRUMENTOS ÓPTICOS Y EQUIPOFOTOGRÁFICO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '268000',
    activity: 'FABRICACIÓN DE SOPORTES MAGNÉTICOS Y ÓPTICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '271000',
    activity:
      'FABRICACIÓN DE MOTORES, GENERADORES Y TRANSFORMADORESELÉCTRICOS, APARATOS DE DISTRIBUCIÓN Y CONTROL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '272000',
    activity: 'FABRICACIÓN DE PILAS, BATERÍAS Y ACUMULADORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '273100',
    activity: 'FABRICACIÓN DE CABLES DE FIBRA ÓPTICA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '273200',
    activity: 'FABRICACIÓN DE OTROS HILOS Y CABLES ELÉCTRICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '273300',
    activity: 'FABRICACIÓN DE DISPOSITIVOS DE CABLEADO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '274000',
    activity: 'FABRICACIÓN DE EQUIPO ELÉCTRICO DE ILUMINACIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '275000',
    activity: 'FABRICACIÓN DE APARATOS DE USO DOMÉSTICO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '279000',
    activity: 'FABRICACIÓN DE OTROS TIPOS DE EQUIPO ELÉCTRICO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '281100',
    activity:
      'FABRICACIÓN DE MOTORES Y TURBINAS, EXCEPTO PARA AERONAVES,VEHÍCULOS AUTOMOTORES Y MOTOCICLETAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '281200',
    activity: 'FABRICACIÓN DE EQUIPO DE PROPULSIÓN DE FLUIDOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '281300',
    activity: 'FABRICACIÓN DE OTRAS BOMBAS, COMPRESORES, GRIFOS Y VÁLVULAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '281400',
    activity:
      'FABRICACIÓN DE COJINETES, ENGRANAJES, TRENES DE ENGRANAJES Y PIEZASDE TRANSMISIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '281500',
    activity: 'FABRICACIÓN DE HORNOS, CALDERAS Y QUEMADORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '281600',
    activity: 'FABRICACIÓN DE EQUIPO DE ELEVACIÓN Y MANIPULACIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '281700',
    activity:
      'FABRICACIÓN DE MAQUINARIA Y EQUIPO DE OFICINA (EXCEPTO COMPUTADORES YEQUIPO PERIFÉRICO)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '281800',
    activity: 'FABRICACIÓN DE HERRAMIENTAS DE MANO MOTORIZADAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '281900',
    activity: 'FABRICACIÓN DE OTROS TIPOS DE MAQUINARIA DE USO GENERAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '282100',
    activity: 'FABRICACIÓN DE MAQUINARIA AGROPECUARIA Y FORESTAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '282200',
    activity:
      'FABRICACIÓN DE MAQUINARIA PARA LA CONFORMACIÓN DE METALES Y DEMÁQUINAS HERRAMIENTA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '282300',
    activity: 'FABRICACIÓN DE MAQUINARIA METALÚRGICA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '282400',
    activity:
      'FABRICACIÓN DE MAQUINARIA PARA LA EXPLOTACIÓN DE MINAS YCANTERAS Y PARA OBRAS DE CONSTRUCCIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '282500',
    activity:
      'FABRICACIÓN DE MAQUINARIA PARA LA ELABORACIÓN DE ALIMENTOS,BEBIDAS Y TABACO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '282600',
    activity:
      'FABRICACIÓN DE MAQUINARIA PARA LA ELABORACIÓN DE PRODUCTOSTEXTILES, PRENDAS DE VESTIR Y CUEROS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '282900',
    activity: 'FABRICACIÓN DE OTROS TIPOS DE MAQUINARIA DE USO ESPECIAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '291000',
    activity: 'FABRICACIÓN DE VEHÍCULOS AUTOMOTORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '292000',
    activity:
      'FABRICACIÓN DE CARROCERÍAS PARA VEHÍCULOS AUTOMOTORES;FABRICACIÓN DE REMOLQUES Y SEMIRREMOLQUES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '293000',
    activity:
      'FABRICACIÓN DE PARTES, PIEZAS Y ACCESORIOS PARA VEHÍCULOSAUTOMOTORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '301100',
    activity:
      'CONSTRUCCIÓN DE BUQUES, EMBARCACIONES MENORES Y ESTRUCTURAS FLOTANTES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '301200',
    activity: 'CONSTRUCCIÓN DE EMBARCACIONES DE RECREO Y DE DEPORTE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '302000',
    activity: 'FABRICACIÓN DE LOCOMOTORAS Y MATERIAL RODANTE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '303000',
    activity: 'FABRICACIÓN DE AERONAVES, NAVES ESPACIALES Y MAQUINARIA CONEXA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '304000',
    activity: 'FABRICACIÓN DE VEHÍCULOS MILITARES DE COMBATE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '309100',
    activity: 'FABRICACIÓN DE MOTOCICLETAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '309200',
    activity: 'FABRICACIÓN DE BICICLETAS Y DE SILLAS DE RUEDAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '309900',
    activity: 'FABRICACIÓN DE OTROS TIPOS DE EQUIPO DE TRANSPORTE N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '310001',
    activity: 'FABRICACIÓN DE MUEBLES PRINCIPALMENTE DE MADERA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '310009',
    activity: 'FABRICACIÓN DE COLCHONES; FABRICACIÓN DE OTROS MUEBLES N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '321100',
    activity: 'FABRICACIÓN DE JOYAS Y ARTÍCULOS CONEXOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '321200',
    activity: 'FABRICACIÓN DE BISUTERÍA Y ARTÍCULOS CONEXOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '322000',
    activity: 'FABRICACIÓN DE INSTRUMENTOS MUSICALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '323000',
    activity: 'FABRICACIÓN DE ARTÍCULOS DE DEPORTE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '324000',
    activity: 'FABRICACIÓN DE JUEGOS Y JUGUETES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '325001',
    activity: 'ACTIVIDADES DE LABORATORIOS DENTALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '325009',
    activity:
      'FABRICACIÓN DE INSTRUMENTOS Y MATERIALES MÉDICOS,OFTALMOLÓGICOS Y ODONTOLÓGICOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '329000',
    activity: 'OTRAS INDUSTRIAS MANUFACTURERAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331100',
    activity: 'REPARACIÓN DE PRODUCTOS ELABORADOS DE METAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331201',
    activity: 'REPARACIÓN DE MAQUINARIA AGROPECUARIA Y FORESTAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331202',
    activity:
      'REPARACIÓN DE MAQUINARIA METALÚRGICA, PARA LA MINERÍA,EXTRACCIÓN DE PETRÓLEO Y PARA LA CONSTRUCCIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331203',
    activity:
      'REPARACIÓN DE MAQUINARIA PARA LA ELABORACIÓN DE ALIMENTOS,BEBIDAS Y TABACO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331204',
    activity:
      'REPARACIÓN DE MAQUINARIA PARA PRODUCIR TEXTILES, PRENDAS DE VESTIR,ARTÍCULOS DE CUERO Y CALZADO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331209',
    activity:
      'REPARACIÓN DE OTRO TIPO DE MAQUINARIA Y EQUIPOS INDUSTRIALES N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331301',
    activity: 'REPARACIÓN DE EQUIPO DE MEDICIÓN, PRUEBA, NAVEGACIÓN YCONTROL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331309',
    activity: 'REPARACIÓN DE OTROS EQUIPOS ELECTRÓNICOS Y ÓPTICOSN.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331400',
    activity:
      'REPARACIÓN DE EQUIPO ELÉCTRICO (EXCEPTO REPARACIÓN DEEQUIPO Y ENSERES DOMÉSTICOS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331501',
    activity:
      'REPARACIÓN DE BUQUES, EMBARCACIONES MENORES Y ESTRUCTURAS FLOTANTES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331502',
    activity: 'REPARACIÓN DE AERONAVES Y NAVES ESPACIALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331509',
    activity:
      'REPARACIÓN DE OTROS EQUIPOS DE TRANSPORTE N.C.P., EXCEPTOVEHÍCULOS AUTOMOTORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '331900',
    activity: 'REPARACIÓN DE OTROS TIPOS DE EQUIPO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '332000',
    activity: 'INSTALACIÓN DE MAQUINARIA Y EQUIPOS INDUSTRIALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '351011',
    activity: 'GENERACIÓN DE ENERGÍA ELÉCTRICA EN CENTRALESHIDROELÉCTRICAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '351012',
    activity: 'GENERACIÓN DE ENERGÍA ELÉCTRICA EN CENTRALESTERMOELÉCTRICAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '351019',
    activity: 'GENERACIÓN DE ENERGÍA ELÉCTRICA EN OTRAS CENTRALESN.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '351020',
    activity: 'TRANSMISIÓN DE ENERGÍA ELÉCTRICA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '351030',
    activity: 'DISTRIBUCIÓN DE ENERGÍA ELÉCTRICA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '352010',
    activity: 'REGASIFICACIÓN DE GAS NATURAL LICUADO (GNL)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '352020',
    activity:
      'FABRICACIÓN DE GAS; DISTRIBUCIÓN DE COMBUSTIBLES GASEOSOS PORTUBERÍA, EXCEPTO REGASIFICACIÓN DE GNL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '353001',
    activity: 'SUMINISTRO DE VAPOR Y DE AIRE ACONDICIONADO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '353002',
    activity: 'ELABORACIÓN DE HIELO (EXCEPTO FABRICACIÓN DE HIELO SECO)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '360000',
    activity: 'CAPTACIÓN, TRATAMIENTO Y DISTRIBUCIÓN DE AGUA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '370000',
    activity: 'EVACUACIÓN Y TRATAMIENTO DE AGUAS SERVIDAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '381100',
    activity: 'RECOGIDA DE DESECHOS NO PELIGROSOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '381200',
    activity: 'RECOGIDA DE DESECHOS PELIGROSOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '382100',
    activity: 'TRATAMIENTO Y ELIMINACIÓN DE DESECHOS NO PELIGROSOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '382200',
    activity: 'TRATAMIENTO Y ELIMINACIÓN DE DESECHOS PELIGROSOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '383001',
    activity:
      'RECUPERACIÓN Y RECICLAMIENTO DE DESPERDICIOS Y DESECHOSMETÁLICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '383002',
    activity: 'RECUPERACIÓN Y RECICLAMIENTO DE PAPEL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '383003',
    activity: 'RECUPERACIÓN Y RECICLAMIENTO DE VIDRIO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '383009',
    activity:
      'RECUPERACIÓN Y RECICLAMIENTO DE OTROS DESPERDICIOS Y DESECHOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '390000',
    activity:
      'ACTIVIDADES DE DESCONTAMINACIÓN Y OTROS SERVICIOS DE GESTIÓNDE DESECHOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '410010',
    activity: 'CONSTRUCCIÓN DE EDIFICIOS PARA USO RESIDENCIAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '410020',
    activity: 'CONSTRUCCIÓN DE EDIFICIOS PARA USO NO RESIDENCIAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '421000',
    activity: 'CONSTRUCCIÓN DE CARRETERAS Y LÍNEAS DE FERROCARRIL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '422000',
    activity: 'CONSTRUCCIÓN DE PROYECTOS DE SERVICIO PÚBLICO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '429000',
    activity: 'CONSTRUCCIÓN DE OTRAS OBRAS DE INGENIERÍA CIVIL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '431100',
    activity: 'DEMOLICIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '431200',
    activity: 'PREPARACIÓN DEL TERRENO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '432100',
    activity: 'INSTALACIONES ELÉCTRICAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '432200',
    activity: 'INSTALACIONES DE GASFITERÍA, CALEFACCIÓN Y AIRE ACONDICIONADO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '432900',
    activity: 'OTRAS INSTALACIONES PARA OBRAS DE CONSTRUCCIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '433000',
    activity: 'TERMINACIÓN Y ACABADO DE EDIFICIOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '439000',
    activity: 'OTRAS ACTIVIDADES ESPECIALIZADAS DE CONSTRUCCIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '451001',
    activity: 'VENTA AL POR MAYOR DE VEHÍCULOS AUTOMOTORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '451002',
    activity:
      'VENTA AL POR MENOR DE VEHÍCULOS AUTOMOTORES NUEVOS O USADOS (INCLUYECOMPRAVENTA)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '452001',
    activity: 'SERVICIO DE LAVADO DE VEHÍCULOS AUTOMOTORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '452002',
    activity: 'MANTENIMIENTO Y REPARACIÓN DE VEHÍCULOS AUTOMOTORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '453000',
    activity: 'VENTA DE PARTES, PIEZAS Y ACCESORIOS PARA VEHÍCULOS AUTOMOTORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '454001',
    activity: 'VENTA DE MOTOCICLETAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '454002',
    activity: 'VENTA DE PARTES, PIEZAS Y ACCESORIOS DE MOTOCICLETAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '454003',
    activity: 'MANTENIMIENTO Y REPARACIÓN DE MOTOCICLETAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '461001',
    activity: 'CORRETAJE AL POR MAYOR DE PRODUCTOS AGRÍCOLAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '461002',
    activity: 'CORRETAJE AL POR MAYOR DE GANADO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '461009',
    activity: 'OTROS TIPOS DE CORRETAJES O REMATES AL POR MAYOR N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '462010',
    activity: 'VENTA AL POR MAYOR DE MATERIAS PRIMAS AGRÍCOLAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '462020',
    activity: 'VENTA AL POR MAYOR DE ANIMALES VIVOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '462090',
    activity:
      'VENTA AL POR MAYOR DE OTRAS MATERIAS PRIMAS AGROPECUARIAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '463011',
    activity: 'VENTA AL POR MAYOR DE FRUTAS Y VERDURAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '463012',
    activity: 'VENTA AL POR MAYOR DE CARNE Y PRODUCTOS CÁRNICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '463013',
    activity:
      'VENTA AL POR MAYOR DE PRODUCTOS DEL MAR (PESCADOS, MARISCOS Y ALGAS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '463014',
    activity: 'VENTA AL POR MAYOR DE PRODUCTOS DE CONFITERÍA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '463019',
    activity:
      'VENTA AL POR MAYOR DE HUEVOS, LÁCTEOS, ABARROTES Y DE OTROS ALIMENTOSN.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '463020',
    activity: 'VENTA AL POR MAYOR DE BEBIDAS ALCOHÓLICAS Y NO ALCOHÓLICAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '463030',
    activity: 'VENTA AL POR MAYOR DE TABACO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '464100',
    activity:
      'VENTA AL POR MAYOR DE PRODUCTOS TEXTILES, PRENDAS DE VESTIR Y CALZADO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '464901',
    activity: 'VENTA AL POR MAYOR DE MUEBLES, EXCEPTO MUEBLES DE OFICINA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '464902',
    activity:
      'VENTA AL POR MAYOR DE ARTÍCULOS ELÉCTRICOS YELECTRÓNICOS PARA EL HOGAR',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '464903',
    activity:
      'VENTA AL POR MAYOR DE ARTÍCULOS DE PERFUMERÍA, DE TOCADOR YCOSMÉTICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '464904',
    activity: 'VENTA AL POR MAYOR DE ARTÍCULOS DE PAPELERÍA Y ESCRITORIO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '464905',
    activity: 'VENTA AL POR MAYOR DE LIBROS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '464906',
    activity: 'VENTA AL POR MAYOR DE DIARIOS Y REVISTAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '464907',
    activity: 'VENTA AL POR MAYOR DE PRODUCTOS FARMACÉUTICOS Y MEDICINALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '464908',
    activity: 'VENTA AL POR MAYOR DE INSTRUMENTOS CIENTÍFICOS Y QUIRÚRGICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '464909',
    activity: 'VENTA AL POR MAYOR DE OTROS ENSERES DOMÉSTICOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '465100',
    activity:
      'VENTA AL POR MAYOR DE COMPUTADORES, EQUIPO PERIFÉRICO Y PROGRAMASINFORMÁTICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '465200',
    activity:
      'VENTA AL POR MAYOR DE EQUIPO, PARTES Y PIEZAS ELECTRÓNICOS Y DETELECOMUNICACIONES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '465300',
    activity:
      'VENTA AL POR MAYOR DE MAQUINARIA, EQUIPO Y MATERIALES AGROPECUARIOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '465901',
    activity:
      'VENTA AL POR MAYOR DE MAQUINARIA METALÚRGICA, PARA LA MINERÍA,EXTRACCIÓN DE PETRÓLEO Y CONSTRUCCIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '465902',
    activity:
      'VENTA AL POR MAYOR DE MAQUINARIA PARA LA ELABORACIÓN DE ALIMENTOS,BEBIDAS Y TABACO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '465903',
    activity:
      'VENTA AL POR MAYOR DE MAQUINARIA PARA LA INDUSTRIA TEXTIL, DEL CUERO Y DELCALZADO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '465904',
    activity:
      'VENTA AL POR MAYOR DE MAQUINARIA Y EQUIPO DE OFICINA; VENTA AL POR MAYOR DEMUEBLES DE OFICINA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '465905',
    activity:
      'VENTA AL POR MAYOR DE EQUIPO DE TRANSPORTE(EXCEPTO VEHÍCULOSAUTOMOTORES, MOTOCICLETAS Y BICICLETAS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '465909',
    activity: 'VENTA AL POR MAYOR DE OTROS TIPOS DE MAQUINARIA Y EQUIPO N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '466100',
    activity:
      'VENTA AL POR MAYOR DE COMBUSTIBLES SÓLIDOS, LÍQUIDOS YGASEOSOS Y PRODUCTOS CONEXOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '466200',
    activity: 'VENTA AL POR MAYOR DE METALES Y MINERALES METALÍFEROS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '466301',
    activity:
      'VENTA AL POR MAYOR DE MADERA EN BRUTO Y PRODUCTOS PRIMARIOS DE LAELABORACIÓN DE MADERA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '466302',
    activity:
      'VENTA AL POR MAYOR DE MATERIALES DE CONSTRUCCIÓN, ARTÍCULOS DEFERRETERÍA, GASFITERÍA Y CALEFACCIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '466901',
    activity: 'VENTA AL POR MAYOR DE PRODUCTOS QUÍMICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '466902',
    activity: 'VENTA AL POR MAYOR DE DESECHOS METÁLICOS (CHATARRA)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '466909',
    activity:
      'VENTA AL POR MAYOR DE DESPERDICIOS, DESECHOS Y OTROS PRODUCTOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '469000',
    activity: 'VENTA AL POR MAYOR NO ESPECIALIZADA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '471100',
    activity:
      'VENTA AL POR MENOR EN COMERCIOS DE ALIMENTOS, BEBIDAS O TABACO(SUPERMERCADOS E HIPERMERCADOS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '471910',
    activity:
      'VENTA AL POR MENOR EN COMERCIOS DE VESTUARIO Y PRODUCTOS PARA EL HOGAR(GRANDES TIENDAS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '471990',
    activity:
      'OTRAS ACTIVIDADES DE VENTA AL POR MENOR EN COMERCIOS NO ESPECIALIZADOSN.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '472101',
    activity:
      'VENTA AL POR MENOR DE ALIMENTOS EN COMERCIOS ESPECIALIZADOS (ALMACENESPEQUEÑOS Y MINIMARKET)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '472102',
    activity:
      'VENTA AL POR MENOR EN COMERCIOS ESPECIALIZADOS DE CARNE Y PRODUCTOSCÁRNICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '472103',
    activity:
      'VENTA AL POR MENOR EN COMERCIOS ESPECIALIZADOS DE FRUTAS Y VERDURAS(VERDULERÍAS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '472104',
    activity:
      'VENTA AL POR MENOR EN COMERCIOS ESPECIALIZADOS DE PESCADO, MARISCOS YPRODUCTOS CONEXOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '472105',
    activity:
      'VENTA AL POR MENOR EN COMERCIOS ESPECIALIZADOS DE PRODUCTOS DEPANADERÍA Y PASTELERÍA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '472109',
    activity:
      'VENTA AL POR MENOR EN COMERCIOS ESPECIALIZADOS DE HUEVOS, CONFITES YPRODUCTOS ALIMENTICIOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '472200',
    activity:
      'VENTA AL POR MENOR DE BEBIDAS ALCOHÓLICAS Y NO ALCOHÓLICAS ENCOMERCIOS ESPECIALIZADOS (BOTILLERÍAS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '472300',
    activity:
      'VENTA AL POR MENOR DE TABACO Y PRODUCTOS DE TABACO EN COMERCIOSESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '473000',
    activity:
      'VENTA AL POR MENOR DE COMBUSTIBLES PARA VEHÍCULOS AUTOMOTORES ENCOMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '474100',
    activity:
      'VENTA AL POR MENOR DE COMPUTADORES, EQUIPO PERIFÉRICO, PROGRAMASINFORMÁTICOS Y EQUIPO DE TELECOM.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '474200',
    activity:
      'VENTA AL POR MENOR DE EQUIPO DE SONIDO Y DE VIDEO EN COMERCIOSESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '475100',
    activity:
      'VENTA AL POR MENOR DE TELAS, LANAS, HILOS Y SIMILARES EN COMERCIOSESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '475201',
    activity:
      'VENTA AL POR MENOR DE ARTÍCULOS DE FERRETERÍA Y MATERIALES DECONSTRUCCIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '475202',
    activity:
      'VENTA AL POR MENOR DE PINTURAS, BARNICES Y LACAS EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '475203',
    activity:
      'VENTA AL POR MENOR DE PRODUCTOS DE VIDRIO EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '475300',
    activity:
      'VENTA AL POR MENOR DE TAPICES, ALFOMBRAS Y CUBRIMIENTOS PARA PAREDES Y PISOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '475901',
    activity:
      'VENTA AL POR MENOR DE MUEBLES Y COLCHONES EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '475902',
    activity:
      'VENTA AL POR MENOR DE INSTRUMENTOS MUSICALES EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '475909',
    activity:
      'VENTA AL POR MENOR DE APARATOS ELÉCTRICOS, TEXTILES PARA EL HOGAR YOTROS ENSERES DOMÉSTICOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '476101',
    activity: 'VENTA AL POR MENOR DE LIBROS EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '476102',
    activity:
      'VENTA AL POR MENOR DE DIARIOS Y REVISTAS EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '476103',
    activity:
      'VENTA AL POR MENOR DE ARTÍCULOS DE PAPELERÍA Y ESCRITORIO ENCOMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '476200',
    activity:
      'VENTA AL POR MENOR DE GRABACIONES DE MÚSICA Y DE VIDEO EN COMERCIOSESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '476301',
    activity:
      'VENTA AL POR MENOR DE ARTÍCULOS DE CAZA Y PESCA EN COMERCIOSESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '476302',
    activity:
      'VENTA AL POR MENOR DE BICICLETAS Y SUS REPUESTOS EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '476309',
    activity:
      'VENTA AL POR MENOR DE OTROS ARTÍCULOS Y EQUIPOS DE DEPORTE N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '476400',
    activity:
      'VENTA AL POR MENOR DE JUEGOS Y JUGUETES EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477101',
    activity: 'VENTA AL POR MENOR DE CALZADO EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477102',
    activity:
      'VENTA AL POR MENOR DE PRENDAS Y ACCESORIOS DE VESTIR EN COMERCIOSESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477103',
    activity:
      'VENTA AL POR MENOR DE CARTERAS, MALETAS Y OTROS ACCESORIOS DE VIAJE ENCOMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477201',
    activity:
      'VENTA AL POR MENOR DE PRODUCTOS FARMACÉUTICOS Y MEDICINALES ENCOMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477202',
    activity:
      'VENTA AL POR MENOR DE ARTÍCULOS ORTOPÉDICOS EN COMERCIOSESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477203',
    activity:
      'VENTA AL POR MENOR DE ARTÍCULOS DE PERFUMERÍA, DE TOCADOR YCOSMÉTICOS EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477310',
    activity:
      'VENTA AL POR MENOR DE GAS LICUADO EN BOMBONAS (CILINDROS) EN COMERCIOSESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477391',
    activity:
      'VENTA AL POR MENOR DE ALIMENTO Y ACCESORIOS PARA MASCOTAS EN COMERCIOSESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477392',
    activity:
      'VENTA AL POR MENOR DE ARMAS Y MUNICIONES EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477393',
    activity:
      'VENTA AL POR MENOR DE ARTÍCULOS ÓPTICOS EN COMERCIOSESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477394',
    activity:
      'VENTA AL POR MENOR DE ARTÍCULOS DE JOYERÍA, BISUTERÍA YRELOJERÍA EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477395',
    activity:
      'VENTA AL POR MENOR DE CARBÓN, LEÑA Y OTROS COMBUSTIBLES DE USODOMÉSTICO EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477396',
    activity:
      'VENTA AL POR MENOR DE RECUERDOS, ARTESANÍAS Y ARTÍCULOSRELIGIOSOS EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477397',
    activity:
      'VENTA AL POR MENOR DE FLORES, PLANTAS, ARBOLES, SEMILLAS Y ABONOS ENCOMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477398',
    activity: 'VENTA AL POR MENOR DE MASCOTAS EN COMERCIOS ESPECIALIZADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477399',
    activity:
      'VENTA AL POR MENOR DE OTROS PRODUCTOS EN COMERCIOS ESPECIALIZADOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477401',
    activity: 'VENTA AL POR MENOR DE ANTIGÜEDADES EN COMERCIOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477402',
    activity: 'VENTA AL POR MENOR DE ROPA USADA EN COMERCIOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '477409',
    activity:
      'VENTA AL POR MENOR DE OTROS ARTÍCULOS DE SEGUNDA MANO EN COMERCIOSN.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '478100',
    activity:
      'VENTA AL POR MENOR DE ALIMENTOS, BEBIDAS Y TABACO EN PUESTOS DE VENTA YMERCADOS (INCLUYE FERIAS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '478200',
    activity:
      'VENTA AL POR MENOR DE PRODUCTOS TEXTILES, PRENDAS DE VESTIR Y CALZADO ENPUESTOS DE VENTA Y MERCADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '478900',
    activity:
      'VENTA AL POR MENOR DE OTROS PRODUCTOS EN PUESTOS DE VENTA Y MERCADOS(INCLUYE FERIAS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '479100',
    activity: 'VENTA AL POR MENOR POR CORREO, POR INTERNET Y VÍA TELEFÓNICA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '479901',
    activity:
      'VENTA AL POR MENOR REALIZADA POR INDEPENDIENTES EN LA LOCOMOCIÓNCOLECTIVA (LEY 20.388)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '479902',
    activity: 'VENTA AL POR MENOR MEDIANTE MAQUINAS EXPENDEDORAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '479903',
    activity:
      'VENTA AL POR MENOR POR COMISIONISTAS (NO DEPENDIENTES DE COMERCIOS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '479909',
    activity:
      'OTRAS ACTIVIDADES DE VENTA POR MENOR NO REALIZADAS EN COMERCIOS, PUESTOS DEVENTA O MERCADOS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '491100',
    activity: 'TRANSPORTE INTERURBANO DE PASAJEROS POR FERROCARRIL',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '491200',
    activity: 'TRANSPORTE DE CARGA POR FERROCARRIL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '492110',
    activity:
      'TRANSPORTE URBANO Y SUBURBANO DE PASAJEROS VÍA METRO Y METROTREN',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '492120',
    activity:
      'TRANSPORTE URBANO Y SUBURBANO DE PASAJEROS VÍA LOCOMOCIÓNCOLECTIVA',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '492130',
    activity: 'TRANSPORTE DE PASAJEROS VÍA TAXI COLECTIVO',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '492190',
    activity:
      'OTRAS ACTIVIDADES DE TRANSPORTE URBANO Y SUBURBANO DE PASAJEROS PORVÍA TERRESTRE N.C.P.',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '492210',
    activity: 'SERVICIOS DE TRANSPORTE DE ESCOLARES',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '492220',
    activity: 'SERVICIOS DE TRANSPORTE DE TRABAJADORES',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '492230',
    activity:
      'SERVICIOS DE TRANSPORTE DE PASAJEROS EN TAXIS LIBRES Y RADIOTAXIS',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '492240',
    activity: 'SERVICIOS DE TRANSPORTE A TURISTAS',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '492250',
    activity: 'TRANSPORTE DE PASAJEROS EN BUSES INTERURBANOS',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '492290',
    activity:
      'OTRAS ACTIVIDADES DE TRANSPORTE DE PASAJEROS POR VÍA TERRESTRE N.C.P.',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '492300',
    activity: 'TRANSPORTE DE CARGA POR CARRETERA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '493010',
    activity: 'TRANSPORTE POR OLEODUCTOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '493020',
    activity: 'TRANSPORTE POR GASODUCTOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '493090',
    activity: 'OTRAS ACTIVIDADES DE TRANSPORTE POR TUBERÍAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '501100',
    activity: 'TRANSPORTE DE PASAJEROS MARÍTIMO Y DE CABOTAJE',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '501200',
    activity: 'TRANSPORTE DE CARGA MARÍTIMO Y DE CABOTAJE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '502100',
    activity: 'TRANSPORTE DE PASAJEROS POR VÍAS DE NAVEGACIÓN INTERIORES',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '502200',
    activity: 'TRANSPORTE DE CARGA POR VÍAS DE NAVEGACIÓN INTERIORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '511000',
    activity: 'TRANSPORTE DE PASAJEROS POR VÍA AÉREA',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '512000',
    activity: 'TRANSPORTE DE CARGA POR VÍA AÉREA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '521001',
    activity: 'EXPLOTACIÓN DE FRIGORÍFICOS PARA ALMACENAMIENTO YDEPÓSITO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '521009',
    activity: 'OTROS SERVICIOS DE ALMACENAMIENTO Y DEPÓSITO N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '522110',
    activity: 'EXPLOTACIÓN DE TERMINALES TERRESTRES DE PASAJEROS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '522120',
    activity:
      'EXPLOTACIÓN DE ESTACIONAMIENTOS DE VEHÍCULOS AUTOMOTORES YPARQUÍMETROS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '522130',
    activity: 'SERVICIOS PRESTADOS POR CONCESIONARIOS DE CARRETERAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '522190',
    activity:
      'ACTIVIDADES DE SERVICIOS VINCULADAS AL TRANSPORTE TERRESTRE N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '522200',
    activity: 'ACTIVIDADES DE SERVICIOS VINCULADAS AL TRANSPORTE ACUÁTICO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '522300',
    activity: 'ACTIVIDADES DE SERVICIOS VINCULADAS AL TRANSPORTE AÉREO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '522400',
    activity: 'MANIPULACIÓN DE LA CARGA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '522910',
    activity: 'AGENCIAS DE ADUANAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '522920',
    activity: 'AGENCIAS DE NAVES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '522990',
    activity: 'OTRAS ACTIVIDADES DE APOYO AL TRANSPORTE N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '531000',
    activity: 'ACTIVIDADES POSTALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '532000',
    activity: 'ACTIVIDADES DE MENSAJERÍA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '551001',
    activity: 'ACTIVIDADES DE HOTELES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '551002',
    activity: 'ACTIVIDADES DE MOTELES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '551003',
    activity: 'ACTIVIDADES DE RESIDENCIALES PARA TURISTAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '551009',
    activity: 'OTRAS ACTIVIDADES DE ALOJAMIENTO PARA TURISTAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '552000',
    activity: 'ACTIVIDADES DE CAMPING Y DE PARQUES PARA CASAS RODANTES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '559001',
    activity: 'ACTIVIDADES DE RESIDENCIALES PARA ESTUDIANTES Y TRABAJADORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '559009',
    activity: 'OTRAS ACTIVIDADES DE ALOJAMIENTO N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '561000',
    activity: 'ACTIVIDADES DE RESTAURANTES Y DE SERVICIO MÓVIL DE COMIDAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '562100',
    activity: 'SUMINISTRO DE COMIDAS POR ENCARGO (SERVICIOS DE BANQUETERÍA)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '562900',
    activity:
      'SUMINISTRO INDUSTRIAL DE COMIDAS POR ENCARGO; CONCESIÓN DE SERVICIOSDE ALIMENTACIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '563001',
    activity:
      'ACTIVIDADES DE DISCOTECAS Y CABARET (NIGHT CLUB), CON PREDOMINIO DELSERVICIO DE BEBIDAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '563009',
    activity: 'OTRAS ACTIVIDADES DE SERVICIO DE BEBIDAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '581100',
    activity: 'EDICIÓN DE LIBROS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '581200',
    activity: 'EDICIÓN DE DIRECTORIOS Y LISTAS DE CORREO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '581300',
    activity: 'EDICIÓN DE DIARIOS, REVISTAS Y OTRAS PUBLICACIONES PERIÓDICAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '581900',
    activity: 'OTRAS ACTIVIDADES DE EDICIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '582000',
    activity: 'EDICIÓN DE PROGRAMAS INFORMÁTICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '591100',
    activity:
      'ACTIVIDADES DE PRODUCCIÓN DE PELÍCULASCINEMATOGRÁFICAS, VIDEOS Y PROGRAMAS DE TELEVISIÓN',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '591200',
    activity:
      'ACTIVIDADES DE POSTPRODUCCIÓN DE PELÍCULASCINEMATOGRÁFICAS, VIDEOS Y PROGRAMAS DE TELEVISIÓN',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '591300',
    activity:
      'ACTIVIDADES DE DISTRIBUCIÓN DE PELÍCULASCINEMATOGRÁFICAS, VIDEOS Y PROGRAMAS DE TELEVISIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '591400',
    activity:
      'ACTIVIDADES DE EXHIBICIÓN DE PELÍCULAS CINEMATOGRÁFICASY CINTAS DE VIDEO',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '592000',
    activity: 'ACTIVIDADES DE GRABACIÓN DE SONIDO Y EDICIÓN DE MÚSICA',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '601000',
    activity: 'TRANSMISIONES DE RADIO',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '602000',
    activity: 'PROGRAMACIÓN Y TRANSMISIONES DE TELEVISIÓN',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '611010',
    activity: 'TELEFONÍA FIJA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '611020',
    activity: 'TELEFONÍA LARGA DISTANCIA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '611030',
    activity: 'TELEVISIÓN DE PAGO POR CABLE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '611090',
    activity: 'OTROS SERVICIOS DE TELECOMUNICACIONES ALÁMBRICAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '612010',
    activity: 'TELEFONÍA MÓVIL CELULAR',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '612020',
    activity: 'RADIOCOMUNICACIONES MÓVILES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '612030',
    activity: 'TELEVISIÓN DE PAGO INALÁMBRICA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '612090',
    activity: 'OTROS SERVICIOS DE TELECOMUNICACIONES INALÁMBRICAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '613010',
    activity: 'TELEFONÍA MÓVIL SATELITAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '613020',
    activity: 'TELEVISIÓN DE PAGO SATELITAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '613090',
    activity: 'OTROS SERVICIOS DE TELECOMUNICACIONES POR SATÉLITE N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '619010',
    activity: 'CENTROS DE LLAMADOS Y CENTROS DE ACCESO A INTERNET',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '619090',
    activity: 'OTRAS ACTIVIDADES DE TELECOMUNICACIONES N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '620100',
    activity: 'ACTIVIDADES DE PROGRAMACIÓN INFORMÁTICA',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '620200',
    activity:
      'ACTIVIDADES DE CONSULTORÍA DE INFORMÁTICA Y DE GESTIÓNDE INSTALACIONES INFORMÁTICAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '620900',
    activity:
      'OTRAS ACTIVIDADES DE TECNOLOGÍA DE LA INFORMACIÓN Y DESERVICIOS INFORMÁTICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '631100',
    activity: 'PROCESAMIENTO DE DATOS, HOSPEDAJE Y ACTIVIDADES CONEXAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '631200',
    activity: 'PORTALES WEB',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '639100',
    activity: 'ACTIVIDADES DE AGENCIAS DE NOTICIAS',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '639900',
    activity: 'OTRAS ACTIVIDADES DE SERVICIOS DE INFORMACIÓN N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '641100',
    activity: 'BANCA CENTRAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '641910',
    activity: 'ACTIVIDADES BANCARIAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '641990',
    activity: 'OTROS TIPOS DE INTERMEDIACIÓN MONETARIA N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '642000',
    activity: 'ACTIVIDADES DE SOCIEDADES DE CARTERA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '643000',
    activity:
      'FONDOS Y SOCIEDADES DE INVERSIÓN Y ENTIDADES FINANCIERAS SIMILARES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '649100',
    activity: 'LEASING FINANCIERO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '649201',
    activity: 'FINANCIERAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '649202',
    activity: 'ACTIVIDADES DE CRÉDITO PRENDARIO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '649203',
    activity: 'CAJAS DE COMPENSACIÓN',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '649209',
    activity: 'OTRAS ACTIVIDADES DE CONCESIÓN DE CRÉDITO N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '649900',
    activity:
      'OTRAS ACTIVIDADES DE SERVICIOS FINANCIEROS, EXCEPTO LAS DE SEGUROS Y FONDOSDE PENSIONES N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '651100',
    activity: 'SEGUROS DE VIDA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '651210',
    activity: 'SEGUROS GENERALES, EXCEPTO ACTIVIDADES DE ISAPRES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '651220',
    activity: 'ACTIVIDADES DE ISAPRES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '652000',
    activity: 'REASEGUROS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '653000',
    activity: 'FONDOS DE PENSIONES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '661100',
    activity: 'ADMINISTRACIÓN DE MERCADOS FINANCIEROS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '661201',
    activity: 'ACTIVIDADES DE SECURITIZADORAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '661202',
    activity: 'CORREDORES DE BOLSA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '661203',
    activity: 'AGENTES DE VALORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '661204',
    activity: 'ACTIVIDADES DE CASAS DE CAMBIO Y OPERADORES DE DIVISA',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '661209',
    activity: 'OTROS SERVICIOS DE CORRETAJE DE VALORES Y COMMODITIES N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '661901',
    activity: 'ACTIVIDADES DE CÁMARAS DE COMPENSACIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '661902',
    activity: 'ADMINISTRACIÓN DE TARJETAS DE CRÉDITO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '661903',
    activity:
      'EMPRESAS DE ASESORÍA Y CONSULTORÍA EN INVERSIÓNFINANCIERA; SOCIEDADES DE APOYO AL GIRO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '661904',
    activity: 'ACTIVIDADES DE CLASIFICADORAS DE RIESGO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '661909',
    activity:
      'OTRAS ACTIVIDADES AUXILIARES DE LAS ACTIVIDADES DE SERVICIOS FINANCIEROSN.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '662100',
    activity:
      'EVALUACIÓN DE RIESGOS Y DAÑOS (INCLUYE ACTIVIDADES DELIQUIDADORES DE SEGUROS)',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '662200',
    activity: 'ACTIVIDADES DE AGENTES Y CORREDORES DE SEGUROS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '662900',
    activity:
      'OTRAS ACTIVIDADES AUXILIARES DE LAS ACTIVIDADES DE SEGUROS Y FONDOS DEPENSIONES',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '663010',
    activity: 'ADMINISTRADORAS DE FONDOS DE PENSIONES (AFP)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '663091',
    activity: 'ADMINISTRADORAS DE FONDOS DE INVERSIÓN',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '663092',
    activity: 'ADMINISTRADORAS DE FONDOS MUTUOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '663093',
    activity:
      'ADMINISTRADORAS DE FICES (FONDOS DE INVERSIÓN DE CAPITAL EXTRANJERO)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '663094',
    activity: 'ADMINISTRADORAS DE FONDOS PARA LA VIVIENDA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '663099',
    activity: 'ADMINISTRADORAS DE FONDOS PARA OTROS FINES N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '681011',
    activity:
      'ALQUILER DE BIENES INMUEBLES AMOBLADOS O CON EQUIPOS Y MAQUINARIAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '681012',
    activity: 'COMPRA, VENTA Y ALQUILER (EXCEPTO AMOBLADOS) DE INMUEBLES',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '681020',
    activity: 'SERVICIOS IMPUTADOS DE ALQUILER DE VIVIENDAS',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '682000',
    activity:
      'ACTIVIDADES INMOBILIARIAS REALIZADAS A CAMBIO DE UNA RETRIBUCIÓN OPOR CONTRATA',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '691001',
    activity: 'SERVICIOS DE ASESORAMIENTO Y REPRESENTACIÓN JURÍDICA',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '691002',
    activity: 'SERVICIO NOTARIAL',
    subjectToIva: 'NO',
    taxCategory: '2',
    availableOnline: 'NO',
  },
  {
    code: '691003',
    activity: 'CONSERVADOR DE BIENES RAÍCES',
    subjectToIva: 'NO',
    taxCategory: '2',
    availableOnline: 'NO',
  },
  {
    code: '691004',
    activity: 'RECEPTORES JUDICIALES',
    subjectToIva: 'NO',
    taxCategory: '2',
    availableOnline: 'SI',
  },
  {
    code: '691009',
    activity:
      'SERVICIOS DE ARBITRAJE; SÍNDICOS DE QUIEBRA Y PERITOS JUDICIALES;OTRAS ACTIVIDADES JURÍDICAS N.C.P.',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '692000',
    activity:
      'ACTIVIDADES DE CONTABILIDAD, TENEDURÍA DE LIBROS Y AUDITORÍA;CONSULTORÍA FISCAL',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '701000',
    activity: 'ACTIVIDADES DE OFICINAS PRINCIPALES',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '702000',
    activity: 'ACTIVIDADES DE CONSULTORÍA DE GESTIÓN',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '711001',
    activity:
      'SERVICIOS DE ARQUITECTURA (DISEÑO DE EDIFICIOS, DIBUJO DE PLANOS DECONSTRUCCIÓN, ENTRE OTROS)',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '711002',
    activity:
      'EMPRESAS DE SERVICIOS DE INGENIERÍA Y ACTIVIDADES CONEXAS DECONSULTORÍA TÉCNICA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '711003',
    activity:
      'SERVICIOS PROFESIONALES DE INGENIERÍA Y ACTIVIDADES CONEXAS DECONSULTORÍA TÉCNICA',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '712001',
    activity:
      'ACTIVIDADES DE PLANTAS DE REVISIÓN TÉCNICA PARAVEHÍCULOS AUTOMOTORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '712009',
    activity:
      'OTROS SERVICIOS DE ENSAYOS Y ANÁLISIS TÉCNICOS (EXCEPTOACTIVIDADES DE PLANTAS DE REVISIÓN TÉCNICA)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '721000',
    activity:
      'INVESTIGACIONES Y DESARROLLO EXPERIMENTAL EN EL CAMPO DE LAS CIENCIASNATURALES Y LA INGENIERÍA',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '722000',
    activity:
      'INVESTIGACIONES Y DESARROLLO EXPERIMENTAL EN EL CAMPO DE LAS CIENCIASSOCIALES Y LAS HUMANIDADES',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '731001',
    activity: 'SERVICIOS DE PUBLICIDAD PRESTADOS POR EMPRESAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '731002',
    activity: 'SERVICIOS DE PUBLICIDAD PRESTADOS POR PROFESIONALES',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '732000',
    activity: 'ESTUDIOS DE MERCADO Y ENCUESTAS DE OPINIÓN PÚBLICA',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'S',
  },
  {
    code: '741001',
    activity: 'ACTIVIDADES DE DISEÑO DE VESTUARIO',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '741002',
    activity: 'ACTIVIDADES DE DISEÑO Y DECORACIÓN DE INTERIORES',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '741009',
    activity: 'OTRAS ACTIVIDADES ESPECIALIZADAS DE DISEÑO N.C.P.',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '742001',
    activity: 'SERVICIOS DE REVELADO, IMPRESIÓN Y AMPLIACIÓN DEFOTOGRAFÍAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '742002',
    activity: 'SERVICIOS Y ACTIVIDADES DE FOTOGRAFÍA',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '742003',
    activity: 'SERVICIOS PERSONALES DE FOTOGRAFÍA',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '749001',
    activity:
      'ASESORÍA Y GESTIÓN EN LA COMPRA O VENTA DE PEQUEÑAS YMEDIANAS EMPRESAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '749002',
    activity: 'SERVICIOS DE TRADUCCIÓN E INTERPRETACIÓN PRESTADOS POREMPRESAS',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '749003',
    activity: 'SERVICIOS PERSONALES DE TRADUCCIÓN E INTERPRETACIÓN',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '749004',
    activity:
      'ACTIVIDADES DE AGENCIAS Y AGENTES DE REPRESENTACIÓN DE ACTORES,DEPORTISTAS Y OTRAS FIGURAS PÚBLICAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '749009',
    activity: 'OTRAS ACTIVIDADES PROFESIONALES, CIENTÍFICAS Y TÉCNICAS N.C.P.',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '750001',
    activity: 'ACTIVIDADES DE CLÍNICAS VETERINARIAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '750002',
    activity:
      'ACTIVIDADES DE VETERINARIOS, TÉCNICOS Y OTRO PERSONAL AUXILIAR,PRESTADOS DE FORMA INDEPENDIENTE',
    subjectToIva: 'NO',
    taxCategory: '2',
    availableOnline: 'SI',
  },
  {
    code: '771000',
    activity: 'ALQUILER DE VEHÍCULOS AUTOMOTORES SIN CHOFER',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'S',
  },
  {
    code: '772100',
    activity: 'ALQUILER Y ARRENDAMIENTO DE EQUIPO RECREATIVO Y DEPORTIVO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '772200',
    activity: 'ALQUILER DE CINTAS DE VIDEO Y DISCOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '772900',
    activity:
      'ALQUILER DE OTROS EFECTOS PERSONALES Y ENSERES DOMÉSTICOS (INCLUYEMOBILIARIO PARA EVENTOS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '773001',
    activity:
      'ALQUILER DE EQUIPOS DE TRANSPORTE SIN OPERARIO, EXCEPTO VEHÍCULOSAUTOMOTORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '773002',
    activity:
      'ALQUILER DE MAQUINARIA Y EQUIPO AGROPECUARIO, FORESTAL, DECONSTRUCCIÓN E ING. CIVIL, SIN OPERARIOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '773003',
    activity:
      'ALQUILER DE MAQUINARIA Y EQUIPO DE OFICINA, SIN OPERARIOS (SIN SERVICIOADMINISTRATIVO)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '773009',
    activity:
      'ALQUILER DE OTROS TIPOS DE MAQUINARIAS Y EQUIPOS SIN OPERARIO N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '774000',
    activity:
      'ARRENDAMIENTO DE PROPIEDAD INTELECTUAL Y SIMILARES, EXCEPTO OBRAS PROTEGIDASPOR DERECHOS DE AUTOR',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '781000',
    activity: 'ACTIVIDADES DE AGENCIAS DE EMPLEO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '782000',
    activity:
      'ACTIVIDADES DE AGENCIAS DE EMPLEO TEMPORAL (INCLUYE EMPRESAS DE SERVICIOSTRANSITORIOS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '783000',
    activity: 'OTRAS ACTIVIDADES DE DOTACIÓN DE RECURSOS HUMANOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '791100',
    activity: 'ACTIVIDADES DE AGENCIAS DE VIAJES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '791200',
    activity: 'ACTIVIDADES DE OPERADORES TURÍSTICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '799000',
    activity:
      'OTROS SERVICIOS DE RESERVAS Y ACTIVIDADES CONEXAS (INCLUYE VENTA DE ENTRADASPARA TEATRO, Y OTROS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '801001',
    activity: 'SERVICIOS DE SEGURIDAD PRIVADA PRESTADOS POR EMPRESAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '801002',
    activity: 'SERVICIO DE TRANSPORTE DE VALORES EN VEHÍCULOS BLINDADOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '801003',
    activity: 'SERVICIOS DE SEGURIDAD PRIVADA PRESTADOS POR INDEPENDIENTES',
    subjectToIva: 'NO',
    taxCategory: '2',
    availableOnline: 'SI',
  },
  {
    code: '802000',
    activity:
      'ACTIVIDADES DE SERVICIOS DE SISTEMAS DE SEGURIDAD (INCLUYE SERVICIOS DECERRAJERÍA)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '803000',
    activity:
      'ACTIVIDADES DE INVESTIGACIÓN (INCLUYE ACTIVIDADES DE INVESTIGADORES YDETECTIVES PRIVADOS)',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '811000',
    activity: 'ACTIVIDADES COMBINADAS DE APOYO A INSTALACIONES',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '812100',
    activity: 'LIMPIEZA GENERAL DE EDIFICIOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '812901',
    activity: 'DESRATIZACIÓN, DESINFECCIÓN Y EXTERMINIO DE PLAGAS NOAGRÍCOLAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '812909',
    activity:
      'OTRAS ACTIVIDADES DE LIMPIEZA DE EDIFICIOS E INSTALACIONES INDUSTRIALESN.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '813000',
    activity:
      'ACTIVIDADES DE PAISAJISMO, SERVICIOS DE JARDINERÍA Y SERVICIOSCONEXOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '821100',
    activity: 'ACTIVIDADES COMBINADAS DE SERVICIOS ADMINISTRATIVOS DE OFICINA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '821900',
    activity:
      'FOTOCOPIADO, PREPARACIÓN DE DOCUMENTOS Y OTRAS ACTIVIDADESESPECIALIZADAS DE APOYO DE OFICINA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '822000',
    activity: 'ACTIVIDADES DE CALL-CENTER',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '823000',
    activity: 'ORGANIZACIÓN DE CONVENCIONES Y EXPOSICIONES COMERCIALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '829110',
    activity: 'ACTIVIDADES DE AGENCIAS DE COBRO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '829120',
    activity: 'ACTIVIDADES DE AGENCIAS DE CALIFICACIÓN CREDITICIA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '829200',
    activity: 'ACTIVIDADES DE ENVASADO Y EMPAQUETADO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '829900',
    activity: 'OTRAS ACTIVIDADES DE SERVICIOS DE APOYO A LAS EMPRESAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '841100',
    activity: 'ACTIVIDADES DE LA ADMINISTRACIÓN PÚBLICA EN GENERAL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '841200',
    activity:
      'REGULACIÓN DE LAS ACTIVIDADES DE ORGANISMOS QUE PRESTAN SERVICIOSSANITARIOS, EDUCATIVOS, CULTURALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '841300',
    activity: 'REGULACIÓN Y FACILITACIÓN DE LA ACTIVIDAD ECONÓMICA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '842100',
    activity: 'RELACIONES EXTERIORES',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '842200',
    activity: 'ACTIVIDADES DE DEFENSA',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '842300',
    activity: 'ACTIVIDADES DE MANTENIMIENTO DEL ORDEN PÚBLICO Y DE SEGURIDAD',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '843010',
    activity: 'FONDO NACIONAL DE SALUD (FONASA)',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '843020',
    activity: 'INSTITUTO DE PREVISIÓN SOCIAL (IPS)',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '843090',
    activity:
      'OTROS PLANES DE SEGURIDAD SOCIAL DE AFILIACIÓN OBLIGATORIA N.C.P.',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '850011',
    activity: 'ENSEÑANZA PREESCOLAR PÚBLICA',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '850012',
    activity:
      'ENSEÑANZA PRIMARIA, SECUNDARIA CIENTÍFICO HUMANISTA YTÉCNICO PROFESIONAL PÚBLICA',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '850021',
    activity: 'ENSEÑANZA PREESCOLAR PRIVADA',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '850022',
    activity:
      'ENSEÑANZA PRIMARIA, SECUNDARIA CIENTÍFICO HUMANISTA YTÉCNICO PROFESIONAL PRIVADA',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '853110',
    activity: 'ENSEÑANZA SUPERIOR EN UNIVERSIDADES PÚBLICAS',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '853120',
    activity: 'ENSEÑANZA SUPERIOR EN UNIVERSIDADES PRIVADAS',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '853201',
    activity: 'ENSEÑANZA SUPERIOR EN INSTITUTOS PROFESIONALES',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '853202',
    activity: 'ENSEÑANZA SUPERIOR EN CENTROS DE FORMACIÓN TÉCNICA',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '854100',
    activity: 'ENSEÑANZA DEPORTIVA Y RECREATIVA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '854200',
    activity: 'ENSEÑANZA CULTURAL',
    subjectToIva: 'NO',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '854901',
    activity: 'ENSEÑANZA PREUNIVERSITARIA',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '854902',
    activity: 'SERVICIOS PERSONALES DE EDUCACIÓN',
    subjectToIva: 'NO',
    taxCategory: '2',
    availableOnline: 'SI',
  },
  {
    code: '854909',
    activity: 'OTROS TIPOS DE ENSEÑANZA N.C.P.',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '855000',
    activity: 'ACTIVIDADES DE APOYO A LA ENSEÑANZA',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '861010',
    activity: 'ACTIVIDADES DE HOSPITALES Y CLÍNICAS PÚBLICAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '861020',
    activity: 'ACTIVIDADES DE HOSPITALES Y CLÍNICAS PRIVADAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '862010',
    activity:
      'ACTIVIDADES DE CENTROS DE SALUD MUNICIPALIZADOS (SERVICIOS DE SALUDPÚBLICA)',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '862021',
    activity:
      'CENTROS MÉDICOS PRIVADOS (ESTABLECIMIENTOS DE ATENCIÓNAMBULATORIA)',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '862022',
    activity:
      'CENTROS DE ATENCIÓN ODONTOLÓGICA PRIVADOS (ESTABLECIMIENTOS DEATENCIÓN AMBULATORIA)',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '862031',
    activity: 'SERVICIOS DE MÉDICOS PRESTADOS DE FORMA INDEPENDIENTE',
    subjectToIva: 'NO',
    taxCategory: '2',
    availableOnline: 'SI',
  },
  {
    code: '862032',
    activity: 'SERVICIOS DE ODONTÓLOGOS PRESTADOS DE FORMA INDEPENDIENTE',
    subjectToIva: 'NO',
    taxCategory: '2',
    availableOnline: 'SI',
  },
  {
    code: '869010',
    activity: 'ACTIVIDADES DE LABORATORIOS CLÍNICOS Y BANCOS DE SANGRE',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '869091',
    activity:
      'OTROS SERVICIOS DE ATENCIÓN DE LA SALUD HUMANA PRESTADOS POR EMPRESAS',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '869092',
    activity:
      'SERVICIOS PRESTADOS DE FORMA INDEPENDIENTE POR OTROS PROFESIONALES DE LASALUD',
    subjectToIva: 'NO',
    taxCategory: '2',
    availableOnline: 'SI',
  },
  {
    code: '871000',
    activity: 'ACTIVIDADES DE ATENCIÓN DE ENFERMERÍA EN INSTITUCIONES',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '872000',
    activity:
      'ACTIVIDADES DE ATENCIÓN EN INSTITUCIONES PARA PERSONAS CONDISCAPACIDAD MENTAL Y TOXICÓMANOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '873000',
    activity:
      'ACTIVIDADES DE ATENCIÓN EN INSTITUCIONES PARA PERSONAS DE EDAD YPERSONAS CON DISCAPACIDAD FÍSICA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '879000',
    activity: 'OTRAS ACTIVIDADES DE ATENCIÓN EN INSTITUCIONES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '881000',
    activity:
      'ACTIVIDADES DE ASISTENCIA SOCIAL SIN ALOJAMIENTO PARA PERSONAS DE EDAD YPERSONAS CON DISCAPACIDAD',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '889000',
    activity: 'OTRAS ACTIVIDADES DE ASISTENCIA SOCIAL SIN ALOJAMIENTO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '900001',
    activity:
      'SERVICIOS DE PRODUCCIÓN DE OBRAS DE TEATRO, CONCIERTOS,ESPECTÁCULOS DE DANZA, OTRAS PROD. ESCÉNICAS',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '900002',
    activity:
      'ACTIVIDADES ARTÍSTICAS REALIZADAS POR BANDAS DE MÚSICA,COMPAÑÍAS DE TEATRO, CIRCENSES Y SIMILARES',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '900003',
    activity:
      'ACTIVIDADES DE ARTISTAS REALIZADAS DE FORMA INDEPENDIENTE: ACTORES,MÚSICOS, ESCRITORES, ENTRE OTROS',
    subjectToIva: 'NO',
    taxCategory: '2',
    availableOnline: 'SI',
  },
  {
    code: '900004',
    activity: 'SERVICIOS PRESTADOS POR PERIODISTAS INDEPENDIENTES',
    subjectToIva: 'NO',
    taxCategory: '2',
    availableOnline: 'SI',
  },
  {
    code: '900009',
    activity:
      'OTRAS ACTIVIDADES CREATIVAS, ARTÍSTICAS Y DE ENTRETENIMIENTO N.C.P.',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '910100',
    activity: 'ACTIVIDADES DE BIBLIOTECAS Y ARCHIVOS',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '910200',
    activity: 'ACTIVIDADES DE MUSEOS, GESTIÓN DE LUGARES Y EDIFICIOSHISTÓRICOS',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '910300',
    activity:
      'ACTIVIDADES DE JARDINES BOTÁNICOS, ZOOLÓGICOS Y RESERVASNATURALES',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '920010',
    activity: 'ACTIVIDADES DE CASINOS DE JUEGOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '920090',
    activity: 'OTRAS ACTIVIDADES DE JUEGOS DE AZAR Y APUESTAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '931101',
    activity: 'HIPÓDROMOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '931102',
    activity: 'GESTIÓN DE SALAS DE BILLAR; GESTIÓN DE SALAS DE BOLOS(BOWLING)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '931109',
    activity: 'GESTIÓN DE OTRAS INSTALACIONES DEPORTIVAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '931201',
    activity: 'ACTIVIDADES DE CLUBES DE FÚTBOL AMATEUR Y PROFESIONAL',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '931209',
    activity: 'ACTIVIDADES DE OTROS CLUBES DEPORTIVOS N.C.P.',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '931901',
    activity: 'PROMOCIÓN Y ORGANIZACIÓN DE COMPETENCIAS DEPORTIVAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '931909',
    activity: 'OTRAS ACTIVIDADES DEPORTIVAS N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '932100',
    activity: 'ACTIVIDADES DE PARQUES DE ATRACCIONES Y PARQUES TEMÁTICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '932901',
    activity:
      'GESTIÓN DE SALAS DE POOL; GESTIÓN (EXPLOTACIÓN) DEJUEGOS ELECTRÓNICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '932909',
    activity: 'OTRAS ACTIVIDADES DE ESPARCIMIENTO Y RECREATIVAS N.C.P.',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '941100',
    activity: 'ACTIVIDADES DE ASOCIACIONES EMPRESARIALES Y DE EMPLEADORES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '941200',
    activity: 'ACTIVIDADES DE ASOCIACIONES PROFESIONALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '942000',
    activity: 'ACTIVIDADES DE SINDICATOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '949100',
    activity: 'ACTIVIDADES DE ORGANIZACIONES RELIGIOSAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '949200',
    activity: 'ACTIVIDADES DE ORGANIZACIONES POLÍTICAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '949901',
    activity: 'ACTIVIDADES DE CENTROS DE MADRES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '949902',
    activity: 'ACTIVIDADES DE CLUBES SOCIALES',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '949903',
    activity:
      'FUNDACIONES Y CORPORACIONES; ASOCIACIONES QUE PROMUEVEN ACTIVIDADESCULTURALES O RECREATIVAS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '949904',
    activity: 'CONSEJO DE ADMINISTRACIÓN DE EDIFICIOS Y CONDOMINIOS',
    subjectToIva: 'NO',
    taxCategory: '1',
    availableOnline: 'NO',
  },
  {
    code: '949909',
    activity: 'ACTIVIDADES DE OTRAS ASOCIACIONES N.C.P.',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '951100',
    activity: 'REPARACIÓN DE COMPUTADORES Y EQUIPO PERIFÉRICO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '951200',
    activity:
      'REPARACIÓN DE EQUIPO DE COMUNICACIONES (INCLUYE LA REPARACIÓNTELÉFONOS CELULARES)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '952100',
    activity:
      'REPARACIÓN DE APARATOS ELECTRÓNICOS DE CONSUMO (INCLUYEAPARATOS DE TELEVISIÓN Y RADIO)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '952200',
    activity:
      'REPARACIÓN DE APARATOS DE USO DOMÉSTICO, EQUIPODOMÉSTICO Y DE JARDINERÍA',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '952300',
    activity: 'REPARACIÓN DE CALZADO Y DE ARTÍCULOS DE CUERO',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '952400',
    activity: 'REPARACIÓN DE MUEBLES Y ACCESORIOS DOMÉSTICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '952900',
    activity: 'REPARACIÓN DE OTROS EFECTOS PERSONALES Y ENSERES DOMÉSTICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '960100',
    activity:
      'LAVADO Y LIMPIEZA, INCLUIDA LA LIMPIEZA EN SECO, DE PRODUCTOS TEXTILES Y DEPIEL',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '960200',
    activity: 'PELUQUERÍA Y OTROS TRATAMIENTOS DE BELLEZA',
    subjectToIva: 'G',
    taxCategory: 'G',
    availableOnline: 'SI',
  },
  {
    code: '960310',
    activity: 'SERVICIOS FUNERARIOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '960320',
    activity: 'SERVICIOS DE CEMENTERIOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '960901',
    activity:
      'SERVICIOS DE ADIESTRAMIENTO, GUARDERÍA, PELUQUERÍA, PASEO DEMASCOTAS (EXCEPTO ACT. VETERINARIAS)',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '960902',
    activity:
      'ACTIVIDADES DE SALONES DE MASAJES, BAÑOS TURCOS, SAUNAS, SERVICIO DEBAÑOS PÚBLICOS',
    subjectToIva: 'SI',
    taxCategory: '1',
    availableOnline: 'SI',
  },
  {
    code: '960909',
    activity: 'OTRAS ACTIVIDADES DE SERVICIOS PERSONALES N.C.P.',
    subjectToIva: 'NO',
    taxCategory: '2',
    availableOnline: 'SI',
  },
  {
    code: '970000',
    activity:
      'ACTIVIDADES DE LOS HOGARES COMO EMPLEADORES DE PERSONAL DOMÉSTICO',
    subjectToIva: 'NO',
    taxCategory: 'G',
    availableOnline: 'NO',
  },
  {
    code: '990000',
    activity: 'ACTIVIDADES DE ORGANIZACIONES Y ÓRGANOS EXTRATERRITORIALES',
    subjectToIva: 'G',
    taxCategory: '1',
    availableOnline: 'NO',
  },
] as const;

export type EconomicActivity = (typeof ECONOMIC_ACTIVITIES)[number];
